import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/hooks/use-toast";
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';

interface ShareLinkProps {
  shareableLink: string;
}

const ShareLink: React.FC<ShareLinkProps> = ({ shareableLink }) => {
  const { toast } = useToast();

  const handleShare = async () => {
    if (Capacitor.getPlatform() === 'ios') {
      try {
        await Share.share({
          title: 'Shared Note',
          text: `Check out this note: ${shareableLink}`,
          url: shareableLink,
          dialogTitle: 'Share Note'
        });
      } catch (error) {
        console.error('Error sharing:', error);
        toast({
          title: "Error sharing",
          description: "Please try copying the link manually",
          variant: "destructive",
        });
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareableLink);
        toast({
          title: "Link copied",
          description: "Share link has been copied to clipboard",
        });
      } catch (error) {
        toast({
          title: "Error copying link",
          description: "Please copy the link manually",
          variant: "destructive",
        });
      }
    }
  };

  return (
    <div className="space-y-2">
      <Input 
        value={shareableLink}
        readOnly
        onClick={(e) => e.currentTarget.select()}
      />
      <Button 
        onClick={handleShare}
        className="w-full"
      >
        {Capacitor.getPlatform() === 'ios' ? 'Share Link' : 'Copy Link'}
      </Button>
    </div>
  );
};

export default ShareLink;